var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-inner", staticStyle: { width: "fit-content" } },
    [
      _c(
        "div",
        { staticClass: "section" },
        [
          _vm.isFba
            ? _c(
                "el-form",
                {
                  staticClass: "section",
                  staticStyle: { "flex-direction": "row" },
                  attrs: { disabled: _vm.readonly }
                },
                [
                  _c(
                    "span",
                    {
                      staticStyle: {
                        display: "flex",
                        "align-items": "center",
                        width: "64px"
                      }
                    },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.$t("FbaJob.ValueAddedServices")) + " "
                      )
                    ]
                  ),
                  _c(
                    "el-checkbox-group",
                    {
                      on: { change: _vm.addedServiceChangeHandler },
                      model: {
                        value: _vm.selectedLocalAddedService,
                        callback: function($$v) {
                          _vm.selectedLocalAddedService = $$v
                        },
                        expression: "selectedLocalAddedService"
                      }
                    },
                    _vm._l(_vm.localAddedService, function(item) {
                      return _c(
                        "el-checkbox",
                        {
                          key: item.code,
                          staticStyle: {
                            "margin-left": "8px",
                            "margin-right": "8px"
                          },
                          attrs: { label: item.code },
                          on: {
                            change: function(val) {
                              return _vm.singleAddedServiceChangeHandler(
                                val,
                                item
                              )
                            }
                          }
                        },
                        [_vm._v(" " + _vm._s(item.chineseName) + " ")]
                      )
                    }),
                    1
                  ),
                  _vm.isBookingNew
                    ? _c(
                        "el-checkbox",
                        {
                          staticStyle: {
                            "margin-left": "8px",
                            "margin-right": "8px"
                          },
                          attrs: { no: "destinationPortService" },
                          model: {
                            value: _vm.form.destinationPortService,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "destinationPortService", $$v)
                            },
                            expression: "form.destinationPortService"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t("SeaExport.PortOfDestinationServices")
                            )
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm.viewSource === "bookingWorkspace"
                    ? _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "permission",
                              rawName: "v-permission",
                              value: ["button_insurance_toInsure"],
                              expression: "['button_insurance_toInsure']"
                            }
                          ],
                          staticStyle: { "margin-left": "20px" },
                          attrs: {
                            disabled: _vm.isEdit,
                            no: "toInsure",
                            type: "primary"
                          },
                          on: {
                            click: function($event) {
                              return _vm.pm.toInsure()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.Insure")))]
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          !_vm.isFba
            ? _c(
                "el-form",
                [
                  _c(
                    "el-checkbox",
                    {
                      attrs: { disabled: _vm.readonly, no: "booking" },
                      model: {
                        value: _vm.form.booking,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "booking", $$v)
                        },
                        expression: "form.booking"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.Booking")))]
                  ),
                  _c(
                    "el-checkbox",
                    {
                      staticStyle: { "margin-left": "-20px" },
                      attrs: { disabled: _vm.readonly, no: "customs" },
                      on: {
                        change: function(val) {
                          _vm.form.customsBroker = val
                            ? _vm.form.customsBroker
                            : 0
                          _vm.form.customsDeclarationType = val
                            ? _vm.form.customsDeclarationType
                            : -1
                        }
                      },
                      model: {
                        value: _vm.form.customs,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "customs", $$v)
                        },
                        expression: "form.customs"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.CustomsDeclaration")))]
                  ),
                  _c(
                    "el-checkbox",
                    {
                      staticStyle: { "margin-left": "-20px" },
                      attrs: { disabled: _vm.readonly, no: "isInsure" },
                      model: {
                        value: _vm.form.insure,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "insure", $$v)
                        },
                        expression: "form.insure"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.InsureInfo")) + " ")]
                  ),
                  _c(
                    "el-checkbox",
                    {
                      staticStyle: { "margin-left": "-20px" },
                      attrs: {
                        disabled: _vm.readonly,
                        no: "comercialInspectation"
                      },
                      model: {
                        value: _vm.form.comercialInspectation,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "comercialInspectation", $$v)
                        },
                        expression: "form.comercialInspectation"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.CommodityInspection")))]
                  ),
                  _c(
                    "el-checkbox",
                    {
                      staticStyle: { "margin-left": "-20px" },
                      attrs: { disabled: _vm.readonly, no: "heating" },
                      model: {
                        value: _vm.form.heating,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "heating", $$v)
                        },
                        expression: "form.heating"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.Fumigation")))]
                  ),
                  _c(
                    "el-checkbox",
                    {
                      staticStyle: { "margin-left": "-20px" },
                      attrs: { disabled: _vm.readonly, no: "itmService" },
                      model: {
                        value: _vm.form.itmService,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "itmService", $$v)
                        },
                        expression: "form.itmService"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.ForeignTrade")))]
                  ),
                  _c(
                    "el-checkbox",
                    {
                      staticStyle: { "margin-left": "-20px" },
                      attrs: { disabled: _vm.readonly, no: "headwayTail" },
                      model: {
                        value: _vm.form.headwayTail,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "headwayTail", $$v)
                        },
                        expression: "form.headwayTail"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("RailwayExport.isHeadwayTail")))]
                  ),
                  _vm.isBookingNew && _vm.isFba
                    ? _c(
                        "el-checkbox",
                        {
                          staticStyle: { "margin-left": "-20px" },
                          attrs: { no: "destinationPortService" },
                          model: {
                            value: _vm.form.destinationPortService,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "destinationPortService", $$v)
                            },
                            expression: "form.destinationPortService"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t("SeaExport.PortOfDestinationServices")
                            )
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm.viewSource === "bookingWorkspace"
                    ? _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "permission",
                              rawName: "v-permission",
                              value: ["button_insurance_toInsure"],
                              expression: "['button_insurance_toInsure']"
                            }
                          ],
                          staticStyle: { "margin-left": "20px" },
                          attrs: {
                            disabled: _vm.isEdit,
                            no: "toInsure",
                            type: "primary"
                          },
                          on: {
                            click: function($event) {
                              return _vm.pm.toInsure()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.Insure")))]
                      )
                    : _vm._e(),
                  !_vm.isFba
                    ? _c("span", { staticStyle: { "margin-left": "20px" } }, [
                        _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_BusinessType")))
                      ])
                    : _vm._e(),
                  !_vm.isFba
                    ? _c(
                        "el-radio-group",
                        {
                          staticStyle: { "margin-left": "10px" },
                          attrs: {
                            disabled:
                              _vm.readonly || Boolean(_vm.form.lclMasterUuid),
                            no: "lob"
                          },
                          on: { change: _vm.lobChangeHandler },
                          model: {
                            value: _vm.form.lob,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "lob", $$v)
                            },
                            expression: "form.lob"
                          }
                        },
                        [
                          _c("el-radio", { attrs: { no: "RE", label: "RE" } }, [
                            _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Export")))
                          ]),
                          _c(
                            "el-radio",
                            {
                              staticStyle: { "margin-left": "-20px" },
                              attrs: { no: "RI", label: "RI" }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("CargoMsg.Cargo_JobTypeImport"))
                              )
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  !!_vm.templateName
                    ? _c(
                        "span",
                        {
                          staticClass: "blue",
                          staticStyle: {
                            float: "right",
                            "margin-right": "30px",
                            "line-height": "28px",
                            padding: "0 5px",
                            "white-space": "nowrap"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("CargoMsg.Cargo_SopTemplate")) +
                              ": " +
                              _vm._s(_vm.templateName)
                          )
                        ]
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _c(
        "tab-booking-FCLUICustom-layout",
        {
          attrs: { "element-blocks": _vm.elementBlocks, disabled: _vm.readonly }
        },
        [
          _vm.elementDict.jobNo.slaveVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "jobNo" }, slot: "jobNo" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.jobNo.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.jobNo.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    attrs: {
                      value: _vm.form.jobNo,
                      disabled: true,
                      no: "jobNo"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.isZY
            ? [
                _c(
                  "el-form-item",
                  {
                    attrs: { slot: "saleProductCode" },
                    slot: "saleProductCode"
                  },
                  [
                    _c("line-label", {
                      staticClass: "blue",
                      attrs: {
                        slot: "label",
                        label: _vm.$t("SeaExport.AllowSaleProduct")
                      },
                      slot: "label"
                    }),
                    _c("cargo-advance-select", {
                      attrs: {
                        "select-type":
                          _vm.selectTypeNames.basic_data_AllowSaleProduct,
                        filterable: "",
                        no: "allowSaleProduct",
                        clearable: "",
                        "data-filter-function": function(p) {
                          if (!p.statusEnabled) {
                            return false
                          }
                          return _vm.isFba ? p.fbaSea : p.seaExportEnabled
                        },
                        "default-value": _vm.form.saleProductCode || ""
                      },
                      on: {
                        parentCallBack: function(p) {
                          _vm.form.saleProductCode = p.value
                        }
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { slot: "fullOrInside" }, slot: "fullOrInside" },
                  [
                    _c("line-label", {
                      staticClass: "blue",
                      attrs: {
                        slot: "label",
                        label: _vm.$t("SeaExport.FullOrInside")
                      },
                      slot: "label"
                    }),
                    _c("cargo-advance-select", {
                      attrs: {
                        "select-type":
                          _vm.selectTypeNames
                            .local_cache_FullOrInside$FULL_OR_INSIDE,
                        no: "fullOrInside",
                        clearable: "",
                        "default-value": _vm.form.fullOrInside || ""
                      },
                      on: {
                        parentCallBack: function(p) {
                          _vm.form.fullOrInside = p.value
                        }
                      }
                    })
                  ],
                  1
                )
              ]
            : _vm._e(),
          _vm.elementDict.customerId.slaveVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "customerId" }, slot: "customerId" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.customerId.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.customerId.label
                    },
                    slot: "label"
                  }),
                  _c(
                    "div",
                    {
                      staticStyle: { display: "flex", "align-items": "center" }
                    },
                    [
                      _c(
                        "el-tooltip",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.showWarningImageB,
                              expression: "showWarningImageB"
                            }
                          ],
                          attrs: {
                            content: _vm.warningImageBTip,
                            placement: "right-end"
                          }
                        },
                        [
                          _c("i", {
                            staticClass: "el-icon-warning red",
                            staticStyle: { cursor: "pointer" }
                          })
                        ]
                      ),
                      !_vm.isFba
                        ? _c("cargo-sales-company-select", {
                            attrs: {
                              no: "customerId",
                              "method-params": {
                                customer: true,
                                active: true,
                                companyLob: "railwayExport"
                              },
                              "check-credit": true,
                              "default-value": _vm.form.customerId || "",
                              disabled: !_vm.customerEnabled,
                              job: _vm.form
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.customerIdChange2ContractHandler(p)
                                _vm.clearPoNo()
                              }
                            }
                          })
                        : _vm._e(),
                      _vm.isFba
                        ? _c("cargo-company-select", {
                            staticStyle: { flex: "1" },
                            attrs: {
                              no: "customerId",
                              "method-params": {
                                customer: true,
                                companyLob: "railwayExport",
                                active: true,
                                fba: true
                              },
                              "check-credit": true,
                              job: _vm.form,
                              "default-value": _vm.form.customerId || "",
                              disabled: !_vm.customerEnabled,
                              "data-filter-function": _vm.fbaCustomerIdFilter
                            },
                            on: {
                              change: function(p) {
                                _vm.customerIdChange2ContractHandler(p)
                                _vm.clearPoNo()
                              }
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.customerLevel.slaveVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "customerLevel" }, slot: "customerLevel" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.customerLevel.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.customerLevel.label
                    },
                    slot: "label"
                  }),
                  _c(
                    "el-tooltip",
                    {
                      attrs: { content: _vm.customerTip, placement: "bottom" }
                    },
                    [
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.customerLevel.level !== "",
                              expression: "customerLevel.level!==''"
                            }
                          ],
                          staticStyle: { color: "#FD9A14" }
                        },
                        [_vm._v("LV" + _vm._s(_vm.customerLevel.level))]
                      ),
                      _c("span", { staticStyle: { color: "#D3A73B" } }, [
                        _vm._v(" " + _vm._s(_vm.customerLevel.customerName))
                      ]),
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.contractStatusLabel,
                              expression: "contractStatusLabel"
                            }
                          ],
                          staticClass: "red"
                        },
                        [_vm._v(" (" + _vm._s(_vm.contractStatusLabel) + ")")]
                      ),
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.advancePaymentLabel,
                              expression: "advancePaymentLabel"
                            }
                          ],
                          staticStyle: { color: "brown" }
                        },
                        [_vm._v(" (" + _vm._s(_vm.advancePaymentLabel) + ")")]
                      ),
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.stampPictureView.businessDocuments.length >
                                0,
                              expression:
                                "stampPictureView.businessDocuments.length > 0"
                            }
                          ],
                          on: {
                            click: function($event) {
                              _vm.stampPictureView.visible = true
                            }
                          }
                        },
                        [
                          _c("img", {
                            staticStyle: { "text-align": "right" },
                            attrs: {
                              title: _vm.$t("Message.BookingSeal"),
                              src: _vm.stampIcon,
                              height: "14"
                            }
                          })
                        ]
                      )
                    ]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.customerContact.slaveVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "customerContact" }, slot: "customerContact" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.customerContact.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.customerContact.label
                    },
                    slot: "label"
                  }),
                  _c(
                    "div",
                    { staticStyle: { display: "flex" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { flex: "1" },
                          attrs: {
                            no: "customerContact",
                            filterable: "",
                            "allow-create": true
                          },
                          model: {
                            value: _vm.form.customerContact,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "customerContact", $$v)
                            },
                            expression: "form.customerContact"
                          }
                        },
                        _vm._l(_vm.contactList, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: {
                              label: item.contactPerson,
                              value: item.contactPerson
                            }
                          })
                        }),
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-link",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.isShowContactPersonDetail,
                              expression: "!isShowContactPersonDetail"
                            }
                          ],
                          class: _vm.form.customerContact ? "" : "not-click",
                          attrs: { no: "Detail" },
                          on: { click: _vm.showContactDialog }
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.Detail")))]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.containerLoadType.slaveVisible
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "containerLoadType" },
                  slot: "containerLoadType"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.containerLoadType.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.containerLoadType.label
                    },
                    slot: "label"
                  }),
                  _c(
                    "el-select",
                    {
                      attrs: {
                        disabled: !_vm.lclslaveEnabled,
                        no: "containerLoadType"
                      },
                      on: {
                        change: function(val) {
                          _vm.pm.containerLoadTypeChange(val)
                        }
                      },
                      model: {
                        value: _vm.form.containerLoadType,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "containerLoadType", $$v)
                        },
                        expression: "form.containerLoadType"
                      }
                    },
                    _vm._l(_vm.containerLoadTypes, function(item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: {
                          label: _vm.isZh ? item.chineseName : item.englishName,
                          value: item.code
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.cargoType.slaveVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "cargoType" }, slot: "cargoType" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.cargoType.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.cargoType.label
                    },
                    slot: "label"
                  }),
                  _c(
                    "el-select",
                    {
                      attrs: { filterable: "" },
                      on: { change: _vm.onCargoTypeChagne },
                      model: {
                        value: _vm.form.cargoType,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "cargoType", $$v)
                        },
                        expression: "form.cargoType"
                      }
                    },
                    _vm._l(_vm.cargoType4JobSelect, function(item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: {
                          label: _vm.isZh ? item.chineseName : item.englishName,
                          value: item.code
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.transportType.slaveVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "transportType" }, slot: "transportType" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.transportType.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.transportType.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    attrs: {
                      disabled: !_vm.lclslaveEnabled,
                      no: "transportType",
                      "select-type":
                        _vm.selectTypeNames.basic_data_TransportationType,
                      "method-params": {
                        companyLob: "railwayExport",
                        transportType: true,
                        active: true
                      },
                      filterable: "",
                      "default-value": _vm.form.transportType,
                      "tag-name":
                        this.$store.getters.language === "zh"
                          ? "chineseName"
                          : "englishName",
                      "tag-value": "code",
                      placeholder: _vm.$t("SeaExport.RequiredItem")
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.form.transportType = p.value
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.fullHalf.slaveVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "fullHalf" }, slot: "fullHalf" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.fullHalf.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.fullHalf.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    attrs: {
                      disabled: !_vm.lclslaveEnabled,
                      no: "fullHalf",
                      "select-type": _vm.selectTypeNames.local_cache_FullHalf,
                      filterable: "",
                      "default-value": _vm.form.fullHalf,
                      placeholder: _vm.$t("SeaExport.RequiredItem")
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.form.fullHalf = p.value
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.transportLine.slaveVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "transportLine" }, slot: "transportLine" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.transportLine.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.transportLine.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    attrs: {
                      disabled: !_vm.lclslaveEnabled,
                      no: "transportLine",
                      "select-type": _vm.selectTypeNames.basic_data_RailwayLine,
                      filterable: "",
                      "default-value": _vm.form.transportLine,
                      placeholder: _vm.$t("SeaExport.RequiredItem"),
                      "tag-name": "name"
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.form.transportLine = p.value
                        _vm.pm.refreshPlanner(p.value)
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.etd.slaveVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "etd" }, slot: "etd" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.etd.isRequire ? "blue" : "",
                    attrs: { slot: "label", label: _vm.elementDict.etd.label },
                    slot: "label"
                  }),
                  _c(
                    "div",
                    { staticStyle: { display: "flex" } },
                    [
                      _c("el-date-picker", {
                        staticClass: "departure-date-picker",
                        staticStyle: {
                          flex: "1",
                          width: "140px",
                          "margin-right": "5px"
                        },
                        attrs: {
                          no: "etd",
                          value: _vm.form.etd,
                          disabled:
                            _vm.form.uuid && _vm.form.lclMasterUuid
                              ? true
                              : !_vm.etdEnabled,
                          type: "date",
                          "value-format": "yyyy-MM-dd"
                        },
                        on: { input: _vm.etdChange }
                      }),
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm._f("filterWeek")(_vm.form.sailingDay))
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.eta.slaveVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "eta" }, slot: "eta" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.eta.isRequire ? "blue" : "",
                    attrs: { slot: "label", label: _vm.elementDict.eta.label },
                    slot: "label"
                  }),
                  _c(
                    "div",
                    { staticStyle: { display: "flex" } },
                    [
                      _c("el-date-picker", {
                        staticStyle: {
                          flex: "1",
                          width: "140px",
                          "margin-right": "5px"
                        },
                        attrs: {
                          disabled: !_vm.lclslaveEnabled,
                          no: "eta",
                          type: "date",
                          "value-format": "yyyy-MM-dd"
                        },
                        on: { input: _vm.etaChange },
                        model: {
                          value: _vm.form.eta,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "eta", $$v)
                          },
                          expression: "form.eta"
                        }
                      }),
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm._f("filterWeek")(_vm.form.etaSailingDay))
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.atd.slaveVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "atd" }, slot: "atd" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.atd.isRequire ? "blue" : "",
                    attrs: { slot: "label", label: _vm.elementDict.atd.label },
                    slot: "label"
                  }),
                  _c(
                    "div",
                    { staticStyle: { display: "flex" } },
                    [
                      _c("el-date-picker", {
                        staticStyle: {
                          flex: "1",
                          width: "140px",
                          "margin-right": "5px"
                        },
                        attrs: {
                          disabled: !_vm.lclslaveEnabled,
                          no: "atd",
                          type: "date",
                          "value-format": "yyyy-MM-dd",
                          clearable: ""
                        },
                        on: { input: _vm.atdChange },
                        model: {
                          value: _vm.form.atd,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "atd", $$v)
                          },
                          expression: "form.atd"
                        }
                      }),
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm._f("filterWeek")(_vm.form.atdSailingDay))
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.ata.slaveVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "ata" }, slot: "ata" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.ata.isRequire ? "blue" : "",
                    attrs: { slot: "label", label: _vm.elementDict.ata.label },
                    slot: "label"
                  }),
                  _c(
                    "div",
                    { staticStyle: { display: "flex" } },
                    [
                      _c("el-date-picker", {
                        staticStyle: {
                          flex: "1",
                          width: "140px",
                          "margin-right": "5px"
                        },
                        attrs: {
                          disabled: !_vm.lclslaveEnabled,
                          no: "ata",
                          type: "date",
                          "value-format": "yyyy-MM-dd",
                          clearable: ""
                        },
                        on: { input: _vm.ataChange },
                        model: {
                          value: _vm.form.ata,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "ata", $$v)
                          },
                          expression: "form.ata"
                        }
                      }),
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm._f("filterWeek")(_vm.form.ataSailingDay))
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.customsDate.slaveVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "customsDate" }, slot: "customsDate" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.customsDate.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.customsDate.label
                    },
                    slot: "label"
                  }),
                  _c("el-date-picker", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      no: "customsDate",
                      type: "date",
                      "value-format": "yyyy-MM-dd"
                    },
                    model: {
                      value: _vm.form.customsDate,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "customsDate", $$v)
                      },
                      expression: "form.customsDate"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.departureStation.slaveVisible
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "departureStation" },
                  slot: "departureStation"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.departureStation.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.departureStation.label
                    },
                    slot: "label"
                  }),
                  _c(
                    "div",
                    { staticStyle: { display: "flex" } },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          disabled: !_vm.lclslaveEnabled,
                          no: "departureStation",
                          "select-type":
                            _vm.selectTypeNames.basic_data_RailwayStation,
                          filterable: "",
                          "default-value": _vm.form.departureStation,
                          placeholder: _vm.$t("SeaExport.RequiredItem")
                        },
                        on: { parentCallBack: _vm.departureStationChange }
                      }),
                      _c(
                        "el-checkbox",
                        {
                          staticStyle: { width: "80px", "padding-left": "5px" },
                          attrs: {
                            disabled: !_vm.lclslaveEnabled,
                            no: "transfer"
                          },
                          model: {
                            value: _vm.form.transfer,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "transfer", $$v)
                            },
                            expression: "form.transfer"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.Transit")))]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value:
                    _vm.form.transfer &&
                    _vm.elementDict.transferStation.slaveVisible,
                  expression:
                    "form.transfer && elementDict.transferStation.slaveVisible"
                }
              ],
              attrs: { slot: "transferStation" },
              slot: "transferStation"
            },
            [
              _c("line-label", {
                class: _vm.elementDict.transferStation.isRequire ? "blue" : "",
                attrs: {
                  slot: "label",
                  label: _vm.elementDict.transferStation.label
                },
                slot: "label"
              }),
              _c("cargo-advance-select", {
                attrs: {
                  disabled: !_vm.lclslaveEnabled,
                  no: "transferStation",
                  "select-type": _vm.selectTypeNames.basic_data_RailwayStation,
                  filterable: "",
                  "default-value": _vm.form.transferStation
                },
                on: {
                  parentCallBack: function(p) {
                    _vm.form.transferStation = p.value
                  }
                }
              })
            ],
            1
          ),
          _vm.elementDict.transitStation.slaveVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "transitStation" }, slot: "transitStation" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.transitStation.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.transitStation.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    attrs: {
                      disabled: !_vm.lclslaveEnabled,
                      no: "transitStation",
                      "select-type":
                        _vm.selectTypeNames.basic_data_RailwayStation,
                      filterable: "",
                      "default-value": _vm.form.transitStation,
                      placeholder: _vm.$t("SeaExport.RequiredItem")
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.form.transitStation = p.value
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.destinationStation.slaveVisible
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "destinationStation" },
                  slot: "destinationStation"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.destinationStation.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.destinationStation.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    attrs: {
                      no: "destinationStation",
                      "select-type":
                        _vm.selectTypeNames.basic_data_RailwayStation,
                      filterable: "",
                      "default-value": _vm.form.destinationStation,
                      placeholder: _vm.$t("SeaExport.RequiredItem")
                    },
                    on: { parentCallBack: _vm.destinationStationChange }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.destinationCountry.slaveVisible
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "destinationCountry" },
                  slot: "destinationCountry"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.destinationCountry.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.destinationCountry.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    attrs: {
                      no: "destinationCountry",
                      "select-type": _vm.selectTypeNames.basic_data_Country,
                      filterable: "",
                      "default-value": _vm.form.destinationCountry
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.form.destinationCountry = p.value
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.cargoSource.slaveVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "cargoSource" }, slot: "cargoSource" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.cargoSource.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.cargoSource.label
                    },
                    slot: "label"
                  }),
                  _c(
                    "el-select",
                    {
                      attrs: {
                        disabled: !_vm.cargoSourceEnabled,
                        no: "cargoSource",
                        placeholder: _vm.$t("SeaExport.PleaseSelect"),
                        size: "mini"
                      },
                      on: {
                        change: function($event) {
                          _vm.form.designationAgent = 0
                          _vm.pm.cargoSourceChange({ fieldName: "cargoSource" })
                        }
                      },
                      model: {
                        value: _vm.form.cargoSource,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "cargoSource", $$v)
                        },
                        expression: "form.cargoSource"
                      }
                    },
                    _vm._l(_vm.CARGO_SOURCES, function(item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { label: item.chineseName, value: item.code }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.customJobType.slaveVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "customJobType" }, slot: "customJobType" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.customJobType.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.customJobType.label
                    },
                    slot: "label"
                  }),
                  _vm.form.lob === "RE"
                    ? _c("cargo-advance-select", {
                        key: "1",
                        ref: "customJobType",
                        attrs: {
                          no: "customJobType",
                          "select-type":
                            _vm.selectTypeNames.basic_data_CutomJobType,
                          filterable: "",
                          "tag-name": _vm.isZh ? "name" : "englishName",
                          "static-options": _vm.customJobTypeList,
                          "method-params": { type: _vm.form.lob },
                          "default-value": _vm.form.customJobType
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.form.customJobType = p.value
                            _vm.onCustomJobTypeChange()
                            _vm.contractRuleFieldChange(
                              _vm.form.customerId,
                              _vm.form.designationAgent
                            )
                          }
                        }
                      })
                    : _vm.form.lob === "RI"
                    ? _c("cargo-advance-select", {
                        key: "2",
                        ref: "customJobType",
                        attrs: {
                          no: "customJobType",
                          "select-type":
                            _vm.selectTypeNames.basic_data_CutomJobType,
                          filterable: "",
                          "tag-name": _vm.isZh ? "name" : "englishName",
                          "static-options": _vm.customJobTypeList,
                          "method-params": { type: _vm.form.lob },
                          "default-value": _vm.form.customJobType
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.form.customJobType = p.value
                            _vm.onCustomJobTypeChange()
                            _vm.contractRuleFieldChange(
                              _vm.form.customerId,
                              _vm.form.designationAgent
                            )
                          }
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm.form.customJobType &&
          _vm.secondaryCustomJobTypeList.length > 0 &&
          _vm.elementDict.secondaryCustomJobType.slaveVisible
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "secondaryCustomJobType" },
                  slot: "secondaryCustomJobType"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.secondaryCustomJobType.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.secondaryCustomJobType.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    ref: "secondaryCustomJobType",
                    attrs: {
                      no: "secondaryCustomJobType",
                      "select-type":
                        _vm.selectTypeNames.basic_data_CutomJobType,
                      filterable: "",
                      cache: false,
                      "default-value": _vm.form.secondaryCustomJobType,
                      "tag-name": _vm.isZh ? "name" : "englishName",
                      "static-options": _vm.secondaryCustomJobTypeList
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.form.secondaryCustomJobType = p.value
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.bookingAgent.slaveVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "bookingAgent" }, slot: "bookingAgent" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.bookingAgent.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.bookingAgent.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    attrs: {
                      disabled: !_vm.lclslaveEnabled,
                      no: "bookingAgent",
                      "select-type": _vm.selectTypeNames.basic_data_Company,
                      "method-params": {
                        companyLob: "railwayExport",
                        bookingAgent: true,
                        active: true
                      },
                      filterable: "",
                      "default-value": _vm.form.bookingAgent || ""
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.form.bookingAgent = p.value
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.portAgent.slaveVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "portAgent" }, slot: "portAgent" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.portAgent.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.portAgent.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    attrs: {
                      disabled: !_vm.lclslaveEnabled,
                      no: "portAgent",
                      "select-type": _vm.selectTypeNames.basic_data_Company,
                      "method-params": {
                        companyLob: "railwayExport",
                        portAgent: true,
                        active: true
                      },
                      filterable: "",
                      "default-value": _vm.form.portAgent || ""
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.form.portAgent = p.value
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.forwardingAgent.slaveVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "forwardingAgent" }, slot: "forwardingAgent" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.forwardingAgent.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.forwardingAgent.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    attrs: {
                      disabled: !_vm.lclslaveEnabled,
                      no: "forwardingAgent",
                      "select-type": _vm.selectTypeNames.basic_data_Company,
                      "method-params": {
                        companyLob: "railwayExport",
                        forwardingAgent: true,
                        active: true
                      },
                      filterable: "",
                      "default-value": _vm.form.forwardingAgent || ""
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.form.forwardingAgent = p.value
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.destinationAgent.slaveVisible
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "destinationAgent" },
                  slot: "destinationAgent"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.destinationAgent.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.destinationAgent.label
                    },
                    slot: "label"
                  }),
                  _c(
                    "el-tooltip",
                    {
                      attrs: {
                        content: _vm.destinationAgentTip,
                        disabled: !_vm.showDestinationAgentWarning,
                        placement: "right-end"
                      }
                    },
                    [
                      _c("cargo-company-select", {
                        ref: "destinationAgent",
                        attrs: {
                          no: "destinationAgent",
                          disabled: !_vm.lclslaveEnabled,
                          "method-params": {
                            overseaAgent: true,
                            active: true,
                            companyLob: "railwayExport"
                          },
                          "check-credit": true,
                          job: _vm.form,
                          "default-value": _vm.form.destinationAgent || "",
                          filterable: "",
                          headers: [_vm.$t("Partners.englishName")],
                          fields: ["englishName"],
                          "tag-name": "englishName"
                        },
                        on: {
                          change: function(p) {
                            _vm.pm.txtDestinationAgentChangeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value:
                    _vm.form.cargoSource === "NC" &&
                    _vm.elementDict.designationAgent.slaveVisible,
                  expression:
                    "form.cargoSource==='NC' && elementDict.designationAgent.slaveVisible"
                }
              ],
              attrs: { slot: "designationAgent" },
              slot: "designationAgent"
            },
            [
              _c("line-label", {
                class: _vm.elementDict.designationAgent.isRequire ? "blue" : "",
                attrs: {
                  slot: "label",
                  label: _vm.elementDict.designationAgent.label
                },
                slot: "label"
              }),
              _c(
                "div",
                { staticStyle: { display: "flex", "align-items": "center" } },
                [
                  _c(
                    "el-tooltip",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showWarningImageA,
                          expression: "showWarningImageA"
                        }
                      ],
                      attrs: {
                        content: _vm.warningImageATip,
                        placement: "right-end"
                      }
                    },
                    [
                      _c("i", {
                        staticClass: "el-icon-warning red",
                        staticStyle: { cursor: "pointer" }
                      })
                    ]
                  ),
                  _c("cargo-advance-select", {
                    attrs: {
                      no: "designationAgent",
                      "select-type": _vm.selectTypeNames.basic_data_Company,
                      disabled: !_vm.designationAgentEnabled,
                      "method-params": { designationAgent: true, active: true },
                      "check-credit": true,
                      "default-value": _vm.form.designationAgent || "",
                      filterable: "",
                      headers: [_vm.$t("Partners.englishName")],
                      fields: ["englishName"],
                      "tag-name": "englishName"
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.pm.designationAgentChangeHandler(p)
                      }
                    }
                  }),
                  _vm.overseaAgentDataProviderChange
                    ? _c("cargo-advance-select", {
                        attrs: {
                          no: "designationAgent2",
                          "select-type": _vm.selectTypeNames.basic_data_Company,
                          cache: false,
                          disabled: !_vm.designationAgentEnabled,
                          "check-credit": true,
                          "default-value": _vm.form.designationAgent || "",
                          filterable: "",
                          headers: [_vm.$t("Partners.englishName")],
                          fields: ["englishName"],
                          "tag-name": "englishName",
                          "static-options": _vm.pm.designationAgentArray
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.pm.designationAgentChangeHandler(p)
                          }
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _vm.elementDict.transportSource.slaveVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "transportSource" }, slot: "transportSource" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.transportSource.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.transportSource.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    attrs: {
                      filterable: "",
                      "select-type":
                        _vm.selectTypeNames.basic_data_TransportSource,
                      no: "transportSource",
                      "default-value": _vm.form.transportSource,
                      cache: false,
                      "tag-value": "code",
                      placeholder: " "
                    },
                    on: {
                      parentCallBack: function(item) {
                        return (_vm.form.transportSource = item.value)
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.statisticArea.slaveVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "statisticArea" }, slot: "statisticArea" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.statisticArea.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.statisticArea.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    attrs: {
                      filterable: "",
                      "select-type":
                        _vm.selectTypeNames.basic_data_StatisticArea,
                      no: "statisticArea",
                      "default-value": _vm.form.statisticArea,
                      cache: false,
                      "tag-value": "code",
                      placeholder: " "
                    },
                    on: {
                      parentCallBack: function(item) {
                        return (_vm.form.statisticArea = item.value)
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.localService.slaveVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "localService" }, slot: "localService" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.localService.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.localService.label
                    },
                    slot: "label"
                  }),
                  _c(
                    "el-checkbox",
                    {
                      attrs: { no: "warehousing" },
                      on: {
                        change: function($event) {
                          return _vm.pm.loadingTermChange("warehousing")
                        }
                      },
                      model: {
                        value: _vm.form.warehousing,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "warehousing", $$v)
                        },
                        expression: "form.warehousing"
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("SeaExport.WarehouseLoadingStorage"))
                      )
                    ]
                  ),
                  _c(
                    "el-checkbox",
                    {
                      attrs: { no: "landTransportation" },
                      on: {
                        change: function($event) {
                          return _vm.pm.loadingTermChange("landTransportation")
                        }
                      },
                      model: {
                        value: _vm.form.landTransportation,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "landTransportation", $$v)
                        },
                        expression: "form.landTransportation"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.DoorLoadingDelivery")))]
                  ),
                  _c(
                    "el-checkbox",
                    {
                      attrs: { no: "selfDeliver" },
                      model: {
                        value: _vm.form.selfDeliver,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "selfDeliver", $$v)
                        },
                        expression: "form.selfDeliver"
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "SeaExport.NotResponsibleForTruckingAndLoading"
                          )
                        )
                      )
                    ]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.warehouseNo.slaveVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "warehouseNo" }, slot: "warehouseNo" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.warehouseNo.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.warehouseNo.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    staticStyle: { "margin-bottom": "10px" },
                    attrs: { no: "warehouseNo" },
                    model: {
                      value: _vm.form.warehouseNo,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "warehouseNo", $$v)
                      },
                      expression: "form.warehouseNo"
                    }
                  }),
                  _c(
                    "el-button",
                    {
                      staticStyle: {
                        "padding-left": "13px",
                        "padding-right": "13px"
                      },
                      attrs: {
                        disabled: true,
                        no: "ObtainTheWarehouseNo",
                        type: "primary"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.ObtainTheWarehouseNo")))]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.paymentMethod.slaveVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "paymentMethod" }, slot: "paymentMethod" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.paymentMethod.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.paymentMethod.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    attrs: {
                      disabled: !_vm.lclslaveEnabled,
                      no: "paymentMethod",
                      "select-type":
                        _vm.selectTypeNames.basic_data_PaymentMethod,
                      "method-params": {
                        companyLob: "railwayExport",
                        paymentMethod: true,
                        active: true
                      },
                      filterable: "",
                      "default-value": _vm.form.paymentMethod,
                      "tag-name":
                        this.$store.getters.language === "zh"
                          ? "chineseName"
                          : "englishName",
                      "tag-value": "code",
                      placeholder: _vm.$t("SeaExport.RequiredItem")
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.form.paymentMethod = p.value
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.mbl.slaveVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "mbl" }, slot: "mbl" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.mbl.isRequire ? "blue" : "",
                    attrs: { slot: "label", label: _vm.elementDict.mbl.label },
                    slot: "label"
                  }),
                  _c("el-input", {
                    attrs: { no: "mbl" },
                    model: {
                      value: _vm.form.mbl,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "mbl", $$v)
                      },
                      expression: "form.mbl"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.vessel.slaveVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "vessel" }, slot: "vessel" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.vessel.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.vessel.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    attrs: { no: "vessel" },
                    model: {
                      value: _vm.form.vessel,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "vessel", $$v)
                      },
                      expression: "form.vessel"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.voyageFlight.slaveVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "voyageFlight" }, slot: "voyageFlight" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.voyageFlight.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.voyageFlight.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    attrs: { no: "voyageFlight" },
                    model: {
                      value: _vm.form.voyageFlight,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "voyageFlight", $$v)
                      },
                      expression: "form.voyageFlight"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.masterJobNo.slaveVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "masterJobNo" }, slot: "masterJobNo" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.masterJobNo.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.masterJobNo.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    attrs: {
                      value: _vm.form.lclMaster ? _vm.form.lclMaster.jobNo : "",
                      disabled: true,
                      no: "MblNo3"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.customerRefNo.slaveVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "customerRefNo" }, slot: "customerRefNo" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.customerRefNo.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.customerRefNo.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-input", {
                    attrs: { no: "customerRefNo", trim: true },
                    model: {
                      value: _vm.form.customerRefNo,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "customerRefNo", $$v)
                      },
                      expression: "form.customerRefNo"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.poNo.slaveVisible
            ? _c(
                "el-form-item",
                {
                  class: _vm.poNoRed ? "poNoClass" : "",
                  attrs: { slot: "poNo" },
                  slot: "poNo"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.poNo.isRequire ? "blue" : "",
                    attrs: { slot: "label", label: _vm.elementDict.poNo.label },
                    slot: "label"
                  }),
                  !_vm.openProjectConfig
                    ? _c("el-input", {
                        attrs: { no: "poNo" },
                        model: {
                          value: _vm.form.poNo,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "poNo", $$v)
                          },
                          expression: "form.poNo"
                        }
                      })
                    : _vm._e(),
                  _vm.openProjectConfig
                    ? _c("cargo-project-select", {
                        attrs: {
                          no: "poNo",
                          "default-value": _vm.form.poNo,
                          "customer-id": _vm.form.customerId,
                          "is-linked": _vm.isProjectLinkedCustomer
                        },
                        on: {
                          change: function(p) {
                            _vm.form.poNo = p.value
                            _vm.form.projectName = p.projectName
                            _vm.changeProject()
                          }
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm.openProjectConfig && _vm.elementDict.projectName.slaveVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "projectName" }, slot: "projectName" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.projectName.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.projectName.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    attrs: { disabled: true },
                    model: {
                      value: _vm.form.projectName,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "projectName", $$v)
                      },
                      expression: "form.projectName"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.openProjectConfig && _vm.elementDict.projectBatch.slaveVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "projectBatch" }, slot: "projectBatch" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.projectBatch.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.projectBatch.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    attrs: { no: "projectBatch" },
                    model: {
                      value: _vm.form.projectBatch,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "projectBatch", $$v)
                      },
                      expression: "form.projectBatch"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.customsBroker.slaveVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "customsBroker" }, slot: "customsBroker" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.customsBroker.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.customsBroker.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    attrs: {
                      disabled: !_vm.customsBrokerEnabled,
                      no: "customsBroker",
                      "select-type": _vm.selectTypeNames.basic_data_Company,
                      "data-filter-function": _vm.customsBrokerFilter,
                      filterable: "",
                      "method-params": { customsBroker: true },
                      "default-value": _vm.form.customsBroker || "",
                      placeholder: _vm.form.customs
                        ? _vm.$t("CargoMsg.Cargo_keyWordsTip")
                        : _vm.$t("SeaExport.PleaseTickCustomsDeclarationOption")
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.pm.customsBrokerChangeHandler(p)
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.customClaim.slaveVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "customClaim" }, slot: "customClaim" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.customClaim.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.customClaim.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    attrs: {
                      no: "customsMethod",
                      disabled: !_vm.customsBrokerEnabled,
                      "select-type": _vm.selectTypeNames.basic_data_CustomsMode,
                      "method-params": { serviceType: 2 },
                      "tag-value": "serialNum",
                      filterable: "",
                      "default-value": _vm.form.customClaim
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.form.customClaim = p.value
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.customsDeclarationType.slaveVisible
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "customsDeclarationType" },
                  slot: "customsDeclarationType"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.customsDeclarationType.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.customsDeclarationType.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    attrs: {
                      no: "customsDeclarationType",
                      disabled: !_vm.customsBrokerEnabled,
                      "select-type":
                        _vm.selectTypeNames.basic_data_CustomsDeclarationType,
                      filterable: "",
                      "default-value":
                        _vm.form.customsDeclarationType === -1
                          ? ""
                          : _vm.form.customsDeclarationType,
                      placeholder: _vm.$t("CargoMsg.Cargo_keyWordsTip")
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.form.customsDeclarationType = p.value
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.tradeTerm.slaveVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "tradeTerm" }, slot: "tradeTerm" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.tradeTerm.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.tradeTerm.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    attrs: {
                      no: "tradeTerm",
                      filterable: "",
                      "select-type": _vm.selectTypeNames.basic_data_TradeTerm,
                      "callback-method-type": "value",
                      "default-value": _vm.form.tradeTerm,
                      "callback-params": { key: "tradeTerm" }
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.form.tradeTerm = p.value
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.incoTerm.slaveVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "incoTerm" }, slot: "incoTerm" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.incoTerm.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.incoTerm.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    attrs: {
                      no: "incoTerm",
                      filterable: "",
                      clearable: false,
                      "select-type": _vm.selectTypeNames.basic_data_IncoTerm,
                      "callback-method-type": "value",
                      "default-value": _vm.form.incoTerm,
                      "callback-params": { key: "incoTerm" },
                      placeholder: " "
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.form.incoTerm = p.value
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.carryingCmp.slaveVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "carryingCmp" }, slot: "carryingCmp" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.carryingCmp.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.carryingCmp.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-company-select", {
                    attrs: {
                      disabled: !_vm.form.landTransportation,
                      no: "carryingCmp",
                      "method-params": { truckCmp: true, active: true },
                      "default-value": _vm.form.carryingCmp || "",
                      placeholder: _vm.form.landTransportation
                        ? _vm.$t("CargoMsg.Cargo_keyWordsTip")
                        : _vm.$t(
                            "SeaExport.PleaseTickDoorLoadingDeliveryOption"
                          )
                    },
                    on: {
                      change: function(p) {
                        _vm.pm.carryingCmpChangeHandler(p)
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.freightTerm.slaveVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "freightTerm" }, slot: "freightTerm" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.freightTerm.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.freightTerm.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    attrs: {
                      no: "freightTerm",
                      "select-type":
                        _vm.selectTypeNames.basic_data_ShippingTerm,
                      filterable: "",
                      clearable: false,
                      "default-value": _vm.form.freightTerm
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.form.freightTerm = p.value
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.warehouseCmp.slaveVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "warehouseCmp" }, slot: "warehouseCmp" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.warehouseCmp.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.warehouseCmp.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-company-select", {
                    attrs: {
                      disabled: !_vm.warehouseEabled,
                      no: "warehouseCmp",
                      "method-params": { warehouse: true, active: true },
                      "default-value": _vm.isFba
                        ? Number(_vm.fbaJob.domesticWarehouse) || ""
                        : _vm.form.warehouseCmp || "",
                      placeholder: _vm.form.warehousing
                        ? _vm.$t("CargoMsg.Cargo_keyWordsTip")
                        : _vm.$t("SeaExport.PleaseSelectWarehouse")
                    },
                    on: {
                      change: function(p) {
                        _vm.pm.warehouseCmpChangeHandler(p)
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.openWarehouse &&
          !_vm.isFba &&
          _vm.elementDict.warehouseName.slaveVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "warehouseName" }, slot: "warehouseName" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.warehouseName.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.warehouseName.label
                    },
                    slot: "label"
                  }),
                  _c(
                    "el-select",
                    {
                      ref: "warehouseName",
                      attrs: {
                        no: "warehouseName",
                        disabled:
                          !_vm.warehouseEabled || !_vm.form.warehouseCmp,
                        "allow-create": true,
                        filterable: "",
                        clearable: true
                      },
                      on: { change: _vm.warehouseNameChangeHandler },
                      model: {
                        value: _vm.form.warehouseName,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "warehouseName", $$v)
                        },
                        expression: "form.warehouseName"
                      }
                    },
                    _vm._l(_vm.warehouseNameList, function(item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: {
                          label: item.warehouseName,
                          value: item.warehouseName
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.diffPlacesCollaborate.slaveVisible
            ? _c(
                "template",
                { slot: "diffPlacesCollaborate" },
                [
                  _c(
                    "el-checkbox",
                    {
                      staticClass: "blue",
                      attrs: { no: "diffPlacesCollaborate" },
                      model: {
                        value: _vm.form.diffPlacesCollaborate,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "diffPlacesCollaborate", $$v)
                        },
                        expression: "form.diffPlacesCollaborate"
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("RailwayExport.isDiffPlacesCollaborate"))
                      )
                    ]
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("RailwayExport.loadingPlaceCompany")
                      }
                    },
                    [
                      _c("cargo-company-select", {
                        attrs: {
                          disabled: !_vm.lclslaveEnabled,
                          no: "loadingPlaceCompany",
                          "method-params": {
                            companyLob: "railwayExport",
                            loadingPlaceCompany: true,
                            active: true
                          },
                          "check-credit": true,
                          job: _vm.form,
                          tooltip: true,
                          "tooltip-tag-name": "englishName",
                          "default-value": _vm.form.loadingPlaceCompany || ""
                        },
                        on: {
                          change: function(p) {
                            _vm.form.loadingPlaceCompany = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("RailwayExport.signBillPlaceCompany")
                      }
                    },
                    [
                      _c("cargo-company-select", {
                        attrs: {
                          disabled: !_vm.lclslaveEnabled,
                          no: "signBillPlaceCompany",
                          "method-params": {
                            companyLob: "railwayExport",
                            signBillPlaceCompany: true,
                            active: true
                          },
                          "check-credit": true,
                          job: _vm.form,
                          tooltip: true,
                          "tooltip-tag-name": "englishName",
                          "default-value": _vm.form.signBillPlaceCompany || ""
                        },
                        on: {
                          change: function(p) {
                            _vm.form.signBillPlaceCompany = p.value
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.fullShipment.slaveVisible
            ? _c(
                "template",
                { slot: "fullShipment" },
                [
                  _c(
                    "el-checkbox",
                    {
                      staticClass: "blue",
                      attrs: {
                        disabled: !_vm.lclslaveEnabled,
                        no: "fullShipment"
                      },
                      model: {
                        value: _vm.form.fullShipment,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "fullShipment", $$v)
                        },
                        expression: "form.fullShipment"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("RailwayExport.isFullShipment")))]
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("RailwayExport.dischargePortCompany")
                      }
                    },
                    [
                      _c("cargo-company-select", {
                        attrs: {
                          disabled: !_vm.lclslaveEnabled,
                          no: "dischargePortCompany",
                          "method-params": {
                            companyLob: "railwayExport",
                            dischargePortCompany: true,
                            active: true
                          },
                          "check-credit": true,
                          job: _vm.form,
                          tooltip: true,
                          "tooltip-tag-name": "englishName",
                          "default-value": _vm.form.dischargePortCompany || ""
                        },
                        on: {
                          change: function(p) {
                            _vm.form.dischargePortCompany = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("RailwayExport.destinationPortCompany")
                      }
                    },
                    [
                      _c("cargo-company-select", {
                        attrs: {
                          disabled: !_vm.lclslaveEnabled,
                          no: "destinationPortCompany",
                          "method-params": {
                            companyLob: "railwayExport",
                            destinationPortCompany: true,
                            active: true
                          },
                          "check-credit": true,
                          job: _vm.form,
                          tooltip: true,
                          "tooltip-tag-name": "englishName",
                          "default-value": _vm.form.destinationPortCompany || ""
                        },
                        on: {
                          change: function(p) {
                            _vm.form.destinationPortCompany = p.value
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.boxOneWay.slaveVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "boxOneWay" }, slot: "boxOneWay" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.boxOneWay.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.boxOneWay.label
                    },
                    slot: "label"
                  }),
                  _c(
                    "el-select",
                    {
                      attrs: { no: "boxOneWay" },
                      model: {
                        value: _vm.form.boxOneWay,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "boxOneWay", $$v)
                        },
                        expression: "form.boxOneWay"
                      }
                    },
                    [
                      _c("el-option", {
                        attrs: {
                          label: _vm.$t("CargoMsg.Cargo_PleaseSelectP"),
                          value: 0
                        }
                      }),
                      _c("el-option", {
                        attrs: {
                          label: _vm.$t("CargoMsg.Cargo_OneWay"),
                          value: 1
                        }
                      }),
                      _c("el-option", {
                        attrs: {
                          label: _vm.$t("CargoMsg.Cargo_Circulation"),
                          value: 2
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.seaEq.slaveVisible
            ? _c(
                "template",
                { slot: "seaEq" },
                [
                  _vm.form.containerLoadType === "FCL" ||
                  _vm.form.containerLoadType === "BB"
                    ? _c(
                        "el-form-item",
                        {
                          staticClass: "auto-width",
                          attrs: { "label-width": "0" }
                        },
                        [
                          _c("booking-sea-eq-data-grid", {
                            ref: "bookingSeaEqDataGrid",
                            attrs: {
                              value: _vm.seaEqList,
                              "container-load-type": _vm.form.containerLoadType,
                              "hide-soc": true,
                              "is-edit": _vm.isEdit,
                              job: _vm.form
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.form.containerLoadType === "BULK"
                    ? _c(
                        "el-form-item",
                        {
                          staticClass: "auto-width",
                          attrs: { "label-width": "0" }
                        },
                        [
                          _c("booking-bulk-data-grid", {
                            attrs: {
                              value: _vm.cargoBulkDetailList,
                              "job-uuid": _vm.form.uuid,
                              "is-edit": _vm.isEdit
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.form.containerLoadType === "SPA"
                    ? _c(
                        "el-form-item",
                        {
                          staticClass: "auto-width",
                          attrs: { "label-width": "0" }
                        },
                        [
                          _c("booking-special-data-grid", {
                            attrs: {
                              value: _vm.seaEqList,
                              "hide-eq-type": true,
                              "hide-soc": true,
                              "is-edit": _vm.isEdit,
                              job: _vm.form
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.quantityConsignActual.slaveVisible
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "quantityConsignActual" },
                  slot: "quantityConsignActual"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.quantityConsignActual.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.quantityConsignActual.label
                    },
                    slot: "label"
                  }),
                  _c(
                    "div",
                    { staticStyle: { display: "flex" } },
                    [
                      _c("auto-number-input", {
                        attrs: { no: "quantityContract", precision: 0, min: 0 },
                        on: {
                          change: function($event) {
                            _vm.pm.jobContractQwcChange(1)
                            _vm.calcEstVolumetricAndChargeWeight()
                          }
                        },
                        model: {
                          value: _vm.form.quantityContract,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "quantityContract", $$v)
                          },
                          expression: "form.quantityContract"
                        }
                      }),
                      _c("span", { staticStyle: { padding: "0 2px" } }, [
                        _vm._v("/")
                      ]),
                      _c("auto-number-input", {
                        ref: "quantityActual",
                        attrs: {
                          disabled: _vm.pm.billChargeFlag,
                          no: "quantityActual",
                          precision: 0,
                          min: 0
                        },
                        on: {
                          change: function($event) {
                            _vm.SEUtils.changeQWCRule(null, function() {
                              _vm.form.quantityContract =
                                _vm.form.quantityActual
                            })
                            _vm.pm.changeSynBillOfLadingQWC()
                            _vm.pm.refContainerUsageQwc(2)
                            _vm.quantityActualChange()
                          }
                        },
                        model: {
                          value: _vm.form.quantityActual,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "quantityActual", $$v)
                          },
                          expression: "form.quantityActual"
                        }
                      }),
                      _c("span", { staticStyle: { width: "65px" } }, [
                        _vm._v("PCS")
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.weightConsignActual.slaveVisible
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "weightConsignActual" },
                  slot: "weightConsignActual"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.weightConsignActual.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.weightConsignActual.label
                    },
                    slot: "label"
                  }),
                  _c(
                    "div",
                    { staticStyle: { display: "flex" } },
                    [
                      _c("auto-number-input", {
                        attrs: { no: "weightContract", precision: 3, min: 0 },
                        on: {
                          change: function($event) {
                            _vm.weightContractChange()
                            _vm.calcEstVolumetricAndChargeWeight()
                          }
                        },
                        model: {
                          value: _vm.form.weightContract,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "weightContract", $$v)
                          },
                          expression: "form.weightContract"
                        }
                      }),
                      _c("span", { staticStyle: { padding: "0 2px" } }, [
                        _vm._v("/")
                      ]),
                      _c("auto-number-input", {
                        ref: "weightActual",
                        attrs: {
                          no: "weightActual",
                          precision: 3,
                          min: 0,
                          disabled: _vm.pm.billChargeFlag
                        },
                        on: { change: _vm.weightActualChange },
                        model: {
                          value: _vm.form.weightActual,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "weightActual", $$v)
                          },
                          expression: "form.weightActual"
                        }
                      }),
                      _c("span", { staticStyle: { width: "65px" } }, [
                        _vm._v("KGS")
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.cubageConsignActual.slaveVisible
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "cubageConsignActual" },
                  slot: "cubageConsignActual"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.cubageConsignActual.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.cubageConsignActual.label
                    },
                    slot: "label"
                  }),
                  _c(
                    "div",
                    { staticStyle: { display: "flex" } },
                    [
                      _c("auto-number-input", {
                        attrs: { no: "cubageContract", precision: 3, min: 0 },
                        on: {
                          change: function($event) {
                            _vm.cubageContractChange()
                            _vm.calcEstVolumetricAndChargeWeight()
                          }
                        },
                        model: {
                          value: _vm.form.cubageContract,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "cubageContract", $$v)
                          },
                          expression: "form.cubageContract"
                        }
                      }),
                      _c("span", { staticStyle: { padding: "0 2px" } }, [
                        _vm._v("/")
                      ]),
                      _c("auto-number-input", {
                        ref: "cubageActual",
                        attrs: {
                          no: "cubageActual",
                          precision: 3,
                          min: 0,
                          disabled: !_vm.cubageActualEnabled
                        },
                        on: { change: _vm.cubageActualChange },
                        model: {
                          value: _vm.form.cubageActual,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "cubageActual", $$v)
                          },
                          expression: "form.cubageActual"
                        }
                      }),
                      _c("span", { staticStyle: { width: "65px" } }, [
                        _vm._v("CBM")
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value:
                    _vm.form.containerLoadType === "BULK" &&
                    _vm.elementDict.insideQuantitySize.slaveVisible,
                  expression:
                    "form.containerLoadType==='BULK' && elementDict.insideQuantitySize.slaveVisible"
                }
              ],
              attrs: { slot: "insideQuantitySize" },
              slot: "insideQuantitySize"
            },
            [
              _c("line-label", {
                class: _vm.elementDict.insideQuantitySize.isRequire
                  ? "blue"
                  : "",
                attrs: {
                  slot: "label",
                  label: _vm.elementDict.insideQuantitySize.label
                },
                slot: "label"
              }),
              _c("el-input-number", {
                staticStyle: { width: "100%" },
                attrs: {
                  no: "insideQuantitySize",
                  precision: 0,
                  controls: false
                },
                model: {
                  value: _vm.form.insideQuantitySize,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "insideQuantitySize", $$v)
                  },
                  expression: "form.insideQuantitySize"
                }
              })
            ],
            1
          ),
          _vm.elementDict.packing.slaveVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "packing" }, slot: "packing" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.packing.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.packing.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-packing-select", {
                    attrs: { no: "packing", "default-value": _vm.form.packing },
                    on: {
                      change: function(p) {
                        _vm.form.packing = p.value
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.cargoChineseName.slaveVisible
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "cargoChineseName" },
                  slot: "cargoChineseName"
                },
                [
                  _c(
                    "div",
                    { attrs: { slot: "label" }, slot: "label" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.cargoChineseName.isRequire
                          ? "blue"
                          : "",
                        attrs: { label: _vm.elementDict.cargoChineseName.label }
                      }),
                      _c("br"),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.isEdit,
                              expression: "isEdit"
                            }
                          ],
                          attrs: {
                            no: "SelectCargoChineseName",
                            type: "primary"
                          },
                          on: {
                            click: function($event) {
                              _vm.showHsCodeSearchDialog(
                                _vm.$t("Message.SelectCargoChineseName"),
                                function(p) {
                                  _vm.form.cargoChineseName = p.commodityName
                                }
                              )
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.Search")))]
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticStyle: { position: "relative" } },
                    [
                      _c("el-input", {
                        attrs: {
                          no: "cargoChineseName",
                          type: "textarea",
                          rows: 6
                        },
                        nativeOn: {
                          dblclick: function($event) {
                            _vm.showAdvanceTextDialog(
                              _vm.$t("SeaExport.ChineseDescriptionOfGoods"),
                              _vm.form.cargoChineseName,
                              false,
                              function(val) {
                                _vm.form.cargoChineseName = val
                              }
                            )
                          }
                        },
                        model: {
                          value: _vm.form.cargoChineseName,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "cargoChineseName", $$v)
                          },
                          expression: "form.cargoChineseName"
                        }
                      }),
                      _c("char-count", {
                        attrs: { value: _vm.form.cargoChineseName }
                      })
                    ],
                    1
                  )
                ]
              )
            : _vm._e(),
          _vm.elementDict.cargoEnglishName.slaveVisible
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "cargoEnglishName" },
                  slot: "cargoEnglishName"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.cargoEnglishName.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.cargoEnglishName.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-rich-textarea", {
                    staticStyle: { height: "110px" },
                    attrs: {
                      "show-count": true,
                      no: "cargoEnglishName",
                      disabled: _vm.readonly,
                      "text-chars": 0,
                      "auto-uppercase": _vm.isUppercaseByConfig
                    },
                    nativeOn: {
                      dblclick: function($event) {
                        _vm.showAdvanceTextDialog(
                          _vm.$t("SeaExport.EnglishDescriptionOfGoods"),
                          _vm.form.cargoEnglishName,
                          _vm.isUppercaseByConfig,
                          function(val) {
                            _vm.form.cargoEnglishName = val
                          }
                        )
                      }
                    },
                    model: {
                      value: _vm.form.cargoEnglishName,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "cargoEnglishName", $$v)
                      },
                      expression: "form.cargoEnglishName"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.mark.slaveVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "mark" }, slot: "mark" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.mark.isRequire ? "blue" : "",
                    attrs: { slot: "label", label: _vm.elementDict.mark.label },
                    slot: "label"
                  }),
                  _c("cargo-rich-textarea", {
                    staticStyle: { height: "110px" },
                    attrs: {
                      "show-count": true,
                      disabled: _vm.readonly,
                      no: "mark",
                      "text-chars": 0,
                      "auto-uppercase": _vm.isUppercaseByConfig
                    },
                    nativeOn: {
                      dblclick: function($event) {
                        _vm.showAdvanceTextDialog(
                          _vm.$t("SeaExport.Marks"),
                          _vm.form.mark,
                          _vm.isUppercaseByConfig,
                          function(val) {
                            _vm.form.mark = val
                          }
                        )
                      }
                    },
                    model: {
                      value: _vm.form.mark,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "mark", $$v)
                      },
                      expression: "form.mark"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.txtSalesOffice.slaveVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "txtSalesOffice" }, slot: "txtSalesOffice" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.txtSalesOffice.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.txtSalesOffice.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    attrs: {
                      value: _vm.txtSalesOffice,
                      disabled: true,
                      no: "txtSalesOffice"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.sales.slaveVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "sales" }, slot: "sales" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.sales.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.sales.label
                    },
                    slot: "label"
                  }),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "justify-content": "space-between"
                      }
                    },
                    [
                      _c("cargo-user-select", {
                        ref: "sales",
                        staticStyle: { flex: "1" },
                        attrs: {
                          disabled: !_vm.saleEnabled,
                          no: "salesRecord",
                          "method-params": {
                            officeId: _vm.salesOfficeCheck
                              ? _vm.$store.getters.currentOfficeId
                              : "",
                            category: "role",
                            shape: "sales"
                          },
                          "default-value": _vm.form.sales || "",
                          "static-options": _vm.salesList,
                          placeholder: _vm.salesPrompt,
                          "merge-load": true
                        },
                        on: {
                          change: function(p) {
                            _vm.form.salesRecord = p.value
                            _vm.pm.salesChangeHandler(p)
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "el-checkbox",
                        {
                          staticStyle: { "margin-left": "5px" },
                          attrs: { no: "provisioned", disabled: true },
                          model: {
                            value: _vm.form.provisioned,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "provisioned", $$v)
                            },
                            expression: "form.provisioned"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.Accrued")))]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.cargoSalesId.slaveVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "cargoSalesId" }, slot: "cargoSalesId" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.cargoSalesId.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.cargoSalesId.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-user-select", {
                    attrs: {
                      no: "cargoSalesId",
                      "method-params": {
                        category: "role",
                        shape: "salesOfGoods"
                      },
                      "default-value": _vm.form.cargoSalesId || "",
                      "merge-load": true,
                      "static-options": _vm.cargoSalesList
                    },
                    on: {
                      change: function(p) {
                        _vm.form.cargoSalesId = p.value
                        _vm.pm.cargoSalesChargeHandler(p)
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.salesDepartment.slaveVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "salesDepartment" }, slot: "salesDepartment" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.salesDepartment.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.salesDepartment.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-department-new-select", {
                    attrs: {
                      disabled: !_vm.form.sales,
                      no: "salesDepartment",
                      enables: true,
                      "sales-id": Number(_vm.form.sales),
                      "office-id": _vm.form.salesOffice,
                      "department-id": Number(_vm.form.salesDepartment)
                    },
                    on: {
                      change: function(p) {
                        _vm.form.salesDepartment = p.value
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.opOffice.slaveVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "opOffice" }, slot: "opOffice" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.opOffice.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.opOffice.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-office-select", {
                    attrs: {
                      disabled:
                        (!_vm.isRegionalCommission &&
                          _vm.pm.isEntrustOrder(true)) ||
                        _vm.opOfficeDisabled,
                      "is-regional-commission": _vm.isRegionalCommission,
                      no: "opOffice",
                      "office-id": Number(_vm.form.opOffice)
                    },
                    on: {
                      change: function(p) {
                        _vm.form.opOffice = p.value
                        _vm.form.opDepartment = 0
                        _vm.opOfficeChargeHandler()
                        _vm.contractRuleFieldChange(
                          _vm.form.customerId,
                          _vm.form.designationAgent
                        )
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.opDepartment.slaveVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "opDepartment" }, slot: "opDepartment" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.opDepartment.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.opDepartment.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-department-select", {
                    attrs: {
                      disabled: _vm.pm.isWithinCloseAccountDate,
                      no: "opDepartment",
                      enables: true,
                      "office-id": Number(_vm.form.opOffice),
                      "department-id": Number(_vm.form.opDepartment)
                    },
                    on: {
                      change: function(p) {
                        _vm.form.opDepartment = p.value
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.op.slaveVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "op" }, slot: "op" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.op.isRequire ? "blue" : "",
                    attrs: { slot: "label", label: _vm.elementDict.op.label },
                    slot: "label"
                  }),
                  _c("cargo-user-select", {
                    attrs: {
                      disabled: !_vm.opEabled,
                      no: "op",
                      "method-params": {
                        officeId: _vm.form.opOffice,
                        category: "role",
                        shape: "op"
                      },
                      "default-value": _vm.form.op || "",
                      "merge-load": true,
                      "static-options": _vm.userPortRoleData.op
                    },
                    on: {
                      change: function(p) {
                        _vm.form.op = p.value
                        _vm.pm.txtOPChangeHandler(p)
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.csrOffice.slaveVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "csrOffice" }, slot: "csrOffice" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.csrOffice.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.csrOffice.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-office-select", {
                    attrs: {
                      no: "csrOffice",
                      disabled: true,
                      "office-id": Number(_vm.form.csrOffice)
                    },
                    on: {
                      change: function(p) {
                        _vm.form.csrOffice = p.value
                        _vm.form.csrDepartment = 0
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.csrDepartment.slaveVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "csrDepartment" }, slot: "csrDepartment" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.csrDepartment.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.csrDepartment.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-department-select", {
                    attrs: {
                      no: "csrDepartment",
                      "office-id": Number(_vm.form.csrOffice),
                      enables: true,
                      "department-id": Number(_vm.form.csrDepartment)
                    },
                    on: {
                      change: function(p) {
                        _vm.form.csrDepartment = p.value
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.csr.slaveVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "csr" }, slot: "csr" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.csr.isRequire ? "blue" : "",
                    attrs: { slot: "label", label: _vm.elementDict.csr.label },
                    slot: "label"
                  }),
                  _c("cargo-user-select", {
                    ref: "csr",
                    attrs: {
                      no: "csr",
                      "method-params": {
                        officeId:
                          _vm.pm.isEntrustOrder || _vm.form.salesOffice === 1
                            ? _vm.form.opOffice
                            : _vm.form.salesOffice,
                        category: "role",
                        shape: "csr"
                      },
                      "default-value": _vm.form.csr || "",
                      "merge-load": true,
                      "static-options": _vm.userPortRoleData.csr
                    },
                    on: {
                      change: function(p) {
                        _vm.pm.csrChangeHandler(p)
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.siteOP.slaveVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "siteOP" }, slot: "siteOP" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.siteOP.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.siteOP.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-user-select", {
                    attrs: {
                      "method-params": {
                        officeId: _vm.form.opOffice,
                        category: "role",
                        shape: "siteOp"
                      },
                      "default-value": _vm.form.siteOP || "",
                      "static-options": _vm.userPortRoleData.siteOp
                    },
                    on: {
                      change: function(p) {
                        _vm.JobUtils.siteOpChangeHandler(_vm.form, p)
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.overseaOp.slaveVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "overseaOp" }, slot: "overseaOp" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.overseaOp.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.overseaOp.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-user-select", {
                    ref: "overseaOp",
                    attrs: {
                      no: "overseaOp",
                      "method-params": { category: "role", shape: "overseaOp" },
                      "default-value": _vm.form.overseaOp || "",
                      "static-options": _vm.isHC
                        ? null
                        : _vm.userPortRoleData.overseaOp ||
                          _vm.overseaAgentUsersList,
                      "merge-load": true
                    },
                    on: {
                      change: function(p) {
                        _vm.form.overseaOp = p.value
                        _vm.pm.overseaOpChangeHandler(p)
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.dcOffice.slaveVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "dcOffice" }, slot: "dcOffice" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.dcOffice.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.dcOffice.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-office-select", {
                    attrs: {
                      no: "dcOffice",
                      disabled: true,
                      "office-id": Number(_vm.form.dcOffice)
                    },
                    on: {
                      change: function(p) {
                        _vm.form.dcOffice = p.value
                        _vm.form.dcDepartment = 0
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.dcDepartment.slaveVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "dcDepartment" }, slot: "dcDepartment" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.dcDepartment.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.dcDepartment.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-department-select", {
                    attrs: {
                      no: "dcDepartment",
                      "office-id": Number(_vm.form.dcOffice),
                      enables: true,
                      "department-id": Number(_vm.form.dcDepartment)
                    },
                    on: {
                      change: function(p) {
                        _vm.form.dcDepartment = p.value
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.dc.slaveVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "dc" }, slot: "dc" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.dc.isRequire ? "blue" : "",
                    attrs: { slot: "label", label: _vm.elementDict.dc.label },
                    slot: "label"
                  }),
                  _c("cargo-user-select", {
                    ref: "dc",
                    attrs: {
                      no: "dc",
                      "method-params": {
                        officeId: _vm.form.opOffice,
                        category: "role",
                        shape: "doc"
                      },
                      "default-value": _vm.form.dc || "",
                      "merge-load": true,
                      "static-options": _vm.userPortRoleData.doc
                    },
                    on: {
                      change: function(p) {
                        _vm.pm.dcChangeHandler(p)
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.plannerOffice &&
          _vm.elementDict.plannerOffice.slaveVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "plannerOffice" }, slot: "plannerOffice" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.plannerOffice.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.plannerOffice.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-office-select", {
                    attrs: {
                      no: "plannerOffice",
                      disabled: true,
                      "office-id": Number(_vm.form.plannerOffice)
                    },
                    on: {
                      change: function(p) {
                        _vm.form.plannerOffice = p.value
                        _vm.form.plannerDepartment = 0
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.plannerDepartment &&
          _vm.elementDict.plannerDepartment.slaveVisible
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "plannerDepartment" },
                  slot: "plannerDepartment"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.plannerDepartment.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.plannerDepartment.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-department-select", {
                    attrs: {
                      no: "plannerDepartment",
                      "office-id": Number(_vm.form.plannerOffice),
                      enables: true,
                      "department-id": Number(_vm.form.plannerDepartment)
                    },
                    on: {
                      change: function(p) {
                        _vm.form.plannerDepartment = p.value
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.planner.slaveVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "planner" }, slot: "planner" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.planner.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.planner.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-user-select", {
                    attrs: {
                      no: "planner",
                      "method-params": {
                        officeId: _vm.form.opOffice,
                        category: "role",
                        shape: "railwayLine"
                      },
                      "default-value": _vm.form.planner || "",
                      "merge-load": true,
                      "static-options": _vm.userPortRoleData.railwayLine
                    },
                    on: {
                      change: function(p) {
                        _vm.form.planner = p.value
                        _vm.pm.txtPlannerChangeHandler(p)
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value:
                    _vm.isAddUserDefinedRoles &&
                    _vm.elementDict.userDefinedRoleId1.slaveVisible,
                  expression:
                    "isAddUserDefinedRoles && elementDict.userDefinedRoleId1.slaveVisible"
                }
              ],
              attrs: { slot: "userDefinedRoleId1" },
              slot: "userDefinedRoleId1"
            },
            [
              _c("line-label", {
                class: _vm.elementDict.userDefinedRoleId1.isRequire
                  ? "blue"
                  : "",
                attrs: {
                  slot: "label",
                  label: _vm.elementDict.userDefinedRoleId1.label
                },
                slot: "label"
              }),
              _c("cargo-user-select", {
                ref: "userDefinedRoleId1",
                attrs: {
                  no: "userDefinedRoleId1",
                  "method-params": {
                    officeId: _vm.$store.getters.currentOfficeId,
                    category: "role",
                    shape: "userDefinedRole1"
                  },
                  "default-value": _vm.form.userDefinedRoleId1 || "",
                  "merge-load": true,
                  "static-options": _vm.userPortRoleData.userDefinedRole1
                },
                on: {
                  change: function(p) {
                    _vm.pm.userDefinedRoleId1Handler(p)
                  }
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value:
                    _vm.isAddUserDefinedRoles &&
                    _vm.elementDict.userDefinedRoleId2.slaveVisible,
                  expression:
                    "isAddUserDefinedRoles && elementDict.userDefinedRoleId2.slaveVisible"
                }
              ],
              attrs: { slot: "userDefinedRoleId2" },
              slot: "userDefinedRoleId2"
            },
            [
              _c("line-label", {
                class: _vm.elementDict.userDefinedRoleId2.isRequire
                  ? "blue"
                  : "",
                attrs: {
                  slot: "label",
                  label: _vm.elementDict.userDefinedRoleId2.label
                },
                slot: "label"
              }),
              _c("cargo-user-select", {
                ref: "userDefinedRoleId2",
                attrs: {
                  no: "userDefinedRoleId2",
                  "method-params": {
                    officeId: _vm.$store.getters.currentOfficeId,
                    category: "role",
                    shape: "userDefinedRole2"
                  },
                  "default-value": _vm.form.userDefinedRoleId2 || "",
                  "merge-load": true,
                  "static-options": _vm.userPortRoleData.userDefinedRole2
                },
                on: {
                  change: function(p) {
                    _vm.pm.userDefinedRoleId2Handler(p)
                  }
                }
              })
            ],
            1
          ),
          _vm.elementDict.userDefinedRoleId3 &&
          _vm.elementDict.userDefinedRoleId3.slaveVisible &&
          _vm.isAddUserDefinedRoles
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "userDefinedRoleId3" },
                  slot: "userDefinedRoleId3"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.userDefinedRoleId3.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.userDefinedRoleId3.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-user-select", {
                    ref: "userDefinedRoleId3",
                    attrs: {
                      no: "userDefinedRoleId3",
                      "method-params": {
                        officeId: _vm.$store.getters.currentOfficeId,
                        category: "role",
                        shape: "userDefinedRole3"
                      },
                      "default-value": _vm.form.userDefinedRoleId3 || "",
                      "merge-load": true,
                      "static-options": _vm.userPortRoleData.userDefinedRole3
                    },
                    on: {
                      change: function(p) {
                        _vm.pm.userDefinedRoleId3Handler(p)
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.userDefinedRoleId4 &&
          _vm.elementDict.userDefinedRoleId4.slaveVisible &&
          _vm.isAddUserDefinedRoles
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "userDefinedRoleId4" },
                  slot: "userDefinedRoleId4"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.userDefinedRoleId4.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.userDefinedRoleId4.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-user-select", {
                    ref: "userDefinedRoleId4",
                    attrs: {
                      no: "userDefinedRoleId4",
                      "method-params": {
                        officeId: _vm.$store.getters.currentOfficeId,
                        category: "role",
                        shape: "userDefinedRole4"
                      },
                      "default-value": _vm.form.userDefinedRoleId4 || "",
                      "merge-load": true,
                      "static-options": _vm.userPortRoleData.userDefinedRole4
                    },
                    on: {
                      change: function(p) {
                        _vm.pm.userDefinedRoleId4Handler(p)
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.userDefinedRoleId5 &&
          _vm.elementDict.userDefinedRoleId5.slaveVisible &&
          _vm.isAddUserDefinedRoles
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "userDefinedRoleId5" },
                  slot: "userDefinedRoleId5"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.userDefinedRoleId5.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.userDefinedRoleId5.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-user-select", {
                    ref: "userDefinedRoleId5",
                    attrs: {
                      no: "userDefinedRoleId5",
                      "method-params": {
                        officeId: _vm.$store.getters.currentOfficeId,
                        category: "role",
                        shape: "userDefinedRole5"
                      },
                      "default-value": _vm.form.userDefinedRoleId5 || "",
                      "merge-load": true
                    },
                    on: {
                      change: function(p) {
                        _vm.pm.userDefinedRoleId5Handler(p)
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.userDefinedRoleId6 &&
          _vm.elementDict.userDefinedRoleId6.slaveVisible &&
          _vm.isAddUserDefinedRoles
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "userDefinedRoleId6" },
                  slot: "userDefinedRoleId6"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.userDefinedRoleId6.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.userDefinedRoleId6.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-user-select", {
                    ref: "userDefinedRoleId6",
                    attrs: {
                      no: "userDefinedRoleId6",
                      "method-params": {
                        officeId: _vm.$store.getters.currentOfficeId,
                        category: "role",
                        shape: "userDefinedRole6"
                      },
                      "default-value": _vm.form.userDefinedRoleId6 || "",
                      "merge-load": true
                    },
                    on: {
                      change: function(p) {
                        _vm.pm.userDefinedRoleId6Handler(p)
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.userDefinedRoleId7 &&
          _vm.elementDict.userDefinedRoleId7.slaveVisible &&
          _vm.isAddUserDefinedRoles
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "userDefinedRoleId7" },
                  slot: "userDefinedRoleId7"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.userDefinedRoleId7.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.userDefinedRoleId7.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-user-select", {
                    ref: "userDefinedRoleId7",
                    attrs: {
                      no: "userDefinedRoleId7",
                      "method-params": {
                        officeId: _vm.$store.getters.currentOfficeId,
                        category: "role",
                        shape: "userDefinedRole7"
                      },
                      "default-value": _vm.form.userDefinedRoleId7 || "",
                      "merge-load": true
                    },
                    on: {
                      change: function(p) {
                        _vm.pm.userDefinedRoleId7Handler(p)
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.userDefinedRoleId8 &&
          _vm.elementDict.userDefinedRoleId8.viewable &&
          _vm.isAddUserDefinedRoles
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "userDefinedRoleId8" },
                  slot: "userDefinedRoleId8"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.userDefinedRoleId8.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.userDefinedRoleId8.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-user-select", {
                    ref: "userDefinedRoleId8",
                    attrs: {
                      no: "userDefinedRoleId8",
                      "method-params": {
                        officeId: _vm.$store.getters.currentOfficeId,
                        category: "role",
                        shape: "userDefinedRole8"
                      },
                      "default-multiple-value": _vm.toNumArray(
                        _vm.form.userDefinedRoleId8
                      ),
                      multiple: true,
                      "merge-load": true,
                      placeholder: _vm.readonly ? " " : ""
                    },
                    on: {
                      change: function(p) {
                        _vm.form.userDefinedRoleId8 = _vm.toTxt(p.value)
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.satisfiedRequests.slaveVisible
            ? _c(
                "el-form-item",
                {
                  staticClass: "auto-width",
                  attrs: { slot: "satisfiedRequests", "label-width": "0" },
                  slot: "satisfiedRequests"
                },
                [
                  _c("special-requests-grid", {
                    ref: "selectedSpecialRequest",
                    attrs: {
                      "is-edit": _vm.isEdit,
                      "customer-id": _vm.form.customerId,
                      lob: _vm.form.lob,
                      job: _vm.form
                    },
                    model: {
                      value: _vm.form.satisfiedRequests,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "satisfiedRequests", $$v)
                      },
                      expression: "form.satisfiedRequests"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.operationContent.slaveVisible
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "operationContent" },
                  slot: "operationContent"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.operationContent.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.operationContent.label
                    },
                    slot: "label"
                  }),
                  _c(
                    "el-tooltip",
                    {
                      attrs: {
                        content: _vm.form.operationContent,
                        placement: "left"
                      }
                    },
                    [
                      _c("div", {
                        attrs: { slot: "content" },
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.form.operationContent
                              ? _vm.form.operationContent.replace(
                                  /[\n]/g,
                                  "</br>"
                                )
                              : _vm.$t("SeaExport.NoData")
                          )
                        },
                        slot: "content"
                      }),
                      _c("el-input", {
                        attrs: {
                          value: _vm.form.operationContent,
                          no: "operationContent",
                          placeholder: _vm.readonly
                            ? ""
                            : _vm.$t(
                                "SeaExport.DoubleClickToAddOperationRequirements"
                              ),
                          type: "textarea",
                          rows: 4
                        },
                        nativeOn: {
                          dblclick: function($event) {
                            _vm.selectOperationReqDialog.value =
                              _vm.form.operationContent
                            _vm.selectOperationReqDialog.visible = _vm.isEdit
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.operationTips.slaveVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "operationTips" }, slot: "operationTips" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.operationTips.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.operationTips.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    attrs: { no: "operationTips", type: "textarea", rows: 4 },
                    nativeOn: {
                      dblclick: function($event) {
                        return _vm.showAdvanceTextDialog(
                          _vm.elementDict.operationTips.label,
                          _vm.form.operationTips,
                          false,
                          function(val) {
                            _vm.form.operationTips = val
                          }
                        )
                      }
                    },
                    model: {
                      value: _vm.form.operationTips,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "operationTips", $$v)
                      },
                      expression: "form.operationTips"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.surchargeTerms.slaveVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "surchargeTerms" }, slot: "surchargeTerms" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.surchargeTerms.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.surchargeTerms.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    attrs: {
                      value: _vm.txtSurchargeTerms,
                      no: "txtSurchargeTerms",
                      placeholder: _vm.readonly
                        ? ""
                        : _vm.$t("SeaExport.DoubleClickToAddExtraChargeClause"),
                      type: "textarea",
                      rows: 4
                    },
                    nativeOn: {
                      dblclick: function($event) {
                        _vm.selectSurchargeTermsDialog.rowData =
                          _vm.form.surchargeTerms
                        _vm.selectSurchargeTermsDialog.visible = true
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.txtWhs.slaveVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "txtWhs" }, slot: "txtWhs" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.txtWhs.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.txtWhs.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    attrs: {
                      disabled: true,
                      no: "txtWhs",
                      type: "textarea",
                      rows: 4,
                      value: _vm.txtWhs
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.remarks.slaveVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "remarks" }, slot: "remarks" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.remarks.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.remarks.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    attrs: { no: "remarks", type: "textarea", rows: 4 },
                    nativeOn: {
                      dblclick: function($event) {
                        return _vm.showAdvanceTextDialog(
                          _vm.elementDict.remarks.label,
                          _vm.form.remarks,
                          false,
                          function(val) {
                            _vm.form.remarks = val
                          }
                        )
                      }
                    },
                    model: {
                      value: _vm.form.remarks,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "remarks", $$v)
                      },
                      expression: "form.remarks"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.userDefinedField1.slaveVisible
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "userDefinedField1" },
                  slot: "userDefinedField1"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.userDefinedField1.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.userDefinedField1.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    attrs: {
                      no: "userDefinedField1",
                      type: "textarea",
                      rows: 4
                    },
                    nativeOn: {
                      dblclick: function($event) {
                        return _vm.showAdvanceTextDialog(
                          _vm.elementDict.userDefinedField1.label,
                          _vm.form.userDefinedField1,
                          function(val) {
                            _vm.form.userDefinedField1 = val
                          }
                        )
                      }
                    },
                    model: {
                      value: _vm.form.userDefinedField1,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "userDefinedField1", $$v)
                      },
                      expression: "form.userDefinedField1"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.userDefinedField2.slaveVisible
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "userDefinedField2" },
                  slot: "userDefinedField2"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.userDefinedField2.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.userDefinedField2.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    attrs: {
                      no: "userDefinedField2",
                      type: "textarea",
                      rows: 4
                    },
                    nativeOn: {
                      dblclick: function($event) {
                        return _vm.showAdvanceTextDialog(
                          _vm.elementDict.userDefinedField2.label,
                          _vm.form.userDefinedField2,
                          function(val) {
                            _vm.form.userDefinedField2 = val
                          }
                        )
                      }
                    },
                    model: {
                      value: _vm.form.userDefinedField2,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "userDefinedField2", $$v)
                      },
                      expression: "form.userDefinedField2"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.userDefinedField3.slaveVisible
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "userDefinedField3" },
                  slot: "userDefinedField3"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.userDefinedField3.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.userDefinedField3.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    attrs: {
                      no: "userDefinedField3",
                      type: "textarea",
                      rows: 4
                    },
                    nativeOn: {
                      dblclick: function($event) {
                        return _vm.showAdvanceTextDialog(
                          _vm.elementDict.userDefinedField3.label,
                          _vm.form.userDefinedField3,
                          function(val) {
                            _vm.form.userDefinedField3 = val
                          }
                        )
                      }
                    },
                    model: {
                      value: _vm.form.userDefinedField3,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "userDefinedField3", $$v)
                      },
                      expression: "form.userDefinedField3"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.userDefinedField4.slaveVisible
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "userDefinedField4" },
                  slot: "userDefinedField4"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.userDefinedField4.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.userDefinedField4.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    attrs: {
                      no: "userDefinedField4",
                      type: "textarea",
                      rows: 4
                    },
                    nativeOn: {
                      dblclick: function($event) {
                        return _vm.showAdvanceTextDialog(
                          _vm.elementDict.userDefinedField4.label,
                          _vm.form.userDefinedField4,
                          function(val) {
                            _vm.form.userDefinedField4 = val
                          }
                        )
                      }
                    },
                    model: {
                      value: _vm.form.userDefinedField4,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "userDefinedField4", $$v)
                      },
                      expression: "form.userDefinedField4"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.exportControlledProduct &&
          _vm.elementDict.exportControlledProduct.slaveVisible
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "exportControlledProduct" },
                  slot: "exportControlledProduct"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.exportControlledProduct.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.exportControlledProduct.label
                    },
                    slot: "label"
                  }),
                  _c(
                    "el-select",
                    {
                      attrs: {
                        no: "exportControlledProduct",
                        disabled: _vm.readonly,
                        placeholder: "",
                        clearable: true,
                        size: "mini"
                      },
                      model: {
                        value: _vm.form.exportControlledProduct,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "exportControlledProduct", $$v)
                        },
                        expression: "form.exportControlledProduct"
                      }
                    },
                    _vm._l(_vm.EXPORT_CONTROLLED_PRODUCT, function(
                      item,
                      index
                    ) {
                      return _c("el-option", {
                        key: index,
                        attrs: {
                          label: _vm.isZh ? item.chineseName : item.englishName,
                          value: item.code
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.taxNature && _vm.elementDict.taxNature.slaveVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "taxNature" }, slot: "taxNature" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.taxNature.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.taxNature.label
                    },
                    slot: "label"
                  }),
                  _c(
                    "el-select",
                    {
                      attrs: {
                        no: "taxNature",
                        placeholder: _vm.$t("SeaExport.PleaseSelect"),
                        size: "mini"
                      },
                      model: {
                        value: _vm.form.taxNature,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "taxNature", $$v)
                        },
                        expression: "form.taxNature"
                      }
                    },
                    _vm._l(_vm.TAX_NATURES, function(item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: {
                          label: _vm.isZh ? item.chineseName : item.englishName,
                          value: item.code
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.elementDict.shipper.slaveVisible,
                  expression: "elementDict.shipper.slaveVisible"
                }
              ],
              staticStyle: { "margin-right": "10px" },
              attrs: {
                slot: "shipper",
                "label-width": "50px",
                "label-position": "left"
              },
              slot: "shipper"
            },
            [
              _c(
                "el-form-item",
                [
                  _c(
                    "template",
                    { slot: "label" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.shipper.isRequire ? "blue" : "",
                        attrs: { label: _vm.elementDict.shipper.label }
                      }),
                      _c("char-count", {
                        staticStyle: {
                          position: "static",
                          display: "block",
                          "font-size": "10px",
                          color: "#909399"
                        },
                        attrs: { form: _vm.form, prefix: "shipper" }
                      })
                    ],
                    1
                  ),
                  _c("cargo-company-select", {
                    staticStyle: { display: "inline-block", width: "196px" },
                    attrs: {
                      no: "shipperId",
                      disabled: _vm.readonly,
                      "method-params": { shipper: true, active: true },
                      "default-value": _vm.form.shipperId || "",
                      placeholder: " "
                    },
                    on: {
                      change: function(data) {
                        _vm.pm.shipperChange(data)
                      }
                    }
                  }),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "5px" },
                      attrs: {
                        no: "shipperBillAddress",
                        disabled: _vm.readonly,
                        type: "primary"
                      },
                      on: {
                        click: function($event) {
                          _vm.billAddressDialog.visible = true
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.CodeSearching")))]
                  )
                ],
                2
              ),
              _vm._l(7, function(i) {
                return _c(
                  "el-form-item",
                  { key: i, attrs: { "label-width": "0" } },
                  [
                    _c("cargo-input", {
                      ref: "shipperLine" + i,
                      refInFor: true,
                      attrs: {
                        disabled: _vm.readonly,
                        no: "shipperLine" + i,
                        "auto-uppercase": _vm.notUppercaseShipperConsigneNotify
                      },
                      on: {
                        change: function() {
                          return _vm.wrapAddr(
                            _vm.form,
                            "shipperLine" + i,
                            i + 1 > 6 ? null : "shipperLine" + (i + 1),
                            ""
                          )
                        }
                      },
                      nativeOn: {
                        dblclick: function($event) {
                          _vm.showAdvanceTextDialog(
                            _vm.$t("SeaExport.Shipper"),
                            _vm.mergeShipperLine(),
                            _vm.notUppercaseShipperConsigneNotify,
                            _vm.splitShipperLine
                          )
                        }
                      },
                      model: {
                        value: _vm.form["shipperLine" + i],
                        callback: function($$v) {
                          _vm.$set(_vm.form, "shipperLine" + i, $$v)
                        },
                        expression: "form['shipperLine'+i]"
                      }
                    })
                  ],
                  1
                )
              })
            ],
            2
          ),
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.elementDict.consignee.slaveVisible,
                  expression: "elementDict.consignee.slaveVisible"
                }
              ],
              staticStyle: { "margin-right": "20px" },
              attrs: {
                slot: "consignee",
                "label-width": "65px",
                "label-position": "left"
              },
              slot: "consignee"
            },
            [
              _c(
                "el-form-item",
                [
                  _c(
                    "template",
                    { slot: "label" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.consignee.isRequire
                          ? "blue"
                          : "",
                        attrs: { label: _vm.elementDict.consignee.label }
                      }),
                      _c("char-count", {
                        staticStyle: {
                          position: "static",
                          display: "block",
                          "font-size": "10px",
                          color: "#909399"
                        },
                        attrs: { form: _vm.form, prefix: "consignee" }
                      })
                    ],
                    1
                  ),
                  _c("cargo-company-select", {
                    staticStyle: { display: "inline-block", width: "196px" },
                    attrs: {
                      no: "consigneeId",
                      disabled: _vm.readonly,
                      "method-params": { consignee: true, active: true },
                      "default-value": _vm.form.consigneeId || "",
                      placeholder: " "
                    },
                    on: {
                      change: function(data) {
                        _vm.pm.consigneeChange(data)
                      }
                    }
                  }),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "5px" },
                      attrs: {
                        no: "consigneeBillAddress",
                        disabled: _vm.readonly,
                        type: "primary"
                      },
                      on: {
                        click: function($event) {
                          _vm.billAddressDialog.visible = true
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.CodeSearching")))]
                  )
                ],
                2
              ),
              _vm._l(7, function(i) {
                return _c(
                  "el-form-item",
                  { key: i, attrs: { "label-width": "0" } },
                  [
                    _c("cargo-input", {
                      ref: "consigneeLine" + i,
                      refInFor: true,
                      attrs: {
                        disabled: _vm.readonly,
                        no: "consigneeLine" + i,
                        "auto-uppercase": _vm.notUppercaseShipperConsigneNotify
                      },
                      on: {
                        change: function() {
                          return _vm.wrapAddr(
                            _vm.form,
                            "consigneeLine" + i,
                            i + 1 > 6 ? null : "consigneeLine" + (i + 1),
                            ""
                          )
                        }
                      },
                      nativeOn: {
                        dblclick: function($event) {
                          _vm.showAdvanceTextDialog(
                            _vm.$t("SeaExport.Consignee"),
                            _vm.mergeConsigneeLine(),
                            _vm.notUppercaseShipperConsigneNotify,
                            _vm.splitConsigneeLine
                          )
                        }
                      },
                      model: {
                        value: _vm.form["consigneeLine" + i],
                        callback: function($$v) {
                          _vm.$set(_vm.form, "consigneeLine" + i, $$v)
                        },
                        expression: "form['consigneeLine'+i]"
                      }
                    })
                  ],
                  1
                )
              })
            ],
            2
          ),
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.elementDict.notify.slaveVisible,
                  expression: "elementDict.notify.slaveVisible"
                }
              ],
              staticStyle: { "margin-right": "20px" },
              attrs: {
                slot: "notify",
                "label-width": "50px",
                "label-position": "left"
              },
              slot: "notify"
            },
            [
              _c(
                "el-form-item",
                [
                  _c(
                    "template",
                    { slot: "label" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.notify.isRequire ? "blue" : "",
                        attrs: { label: _vm.elementDict.notify.label }
                      }),
                      _c("char-count", {
                        staticStyle: {
                          position: "static",
                          display: "block",
                          "font-size": "10px",
                          color: "#909399"
                        },
                        attrs: { form: _vm.form, prefix: "notify" }
                      })
                    ],
                    1
                  ),
                  _c("cargo-company-select", {
                    staticStyle: { display: "inline-block", width: "196px" },
                    attrs: {
                      no: "notifyId",
                      disabled: _vm.readonly,
                      "method-params": { notify: true, active: true },
                      "default-value": _vm.form.notifyId || "",
                      placeholder: " "
                    },
                    on: {
                      change: function(data) {
                        _vm.pm.notifyChange(data)
                      }
                    }
                  }),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "5px" },
                      attrs: {
                        no: "noconifyBillAddress",
                        disabled: _vm.readonly,
                        type: "primary"
                      },
                      on: {
                        click: function($event) {
                          _vm.billAddressDialog.visible = true
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.CodeSearching")))]
                  )
                ],
                2
              ),
              _vm._l(7, function(i) {
                return _c(
                  "el-form-item",
                  { key: i, attrs: { "label-width": "0" } },
                  [
                    _c("cargo-input", {
                      ref: "notifyLine" + i,
                      refInFor: true,
                      attrs: {
                        disabled: _vm.readonly,
                        no: "notifyLine" + i,
                        "auto-uppercase": _vm.notUppercaseShipperConsigneNotify
                      },
                      on: {
                        change: function() {
                          return _vm.wrapAddr(
                            _vm.form,
                            "notifyLine" + i,
                            i + 1 > 6 ? null : "notifyLine" + (i + 1),
                            ""
                          )
                        }
                      },
                      nativeOn: {
                        dblclick: function($event) {
                          _vm.showAdvanceTextDialog(
                            _vm.$t("SeaExport.NotifyParty"),
                            _vm.mergeNotifyLine(),
                            _vm.notUppercaseShipperConsigneNotify,
                            _vm.splitNotifyLine
                          )
                        }
                      },
                      model: {
                        value: _vm.form["notifyLine" + i],
                        callback: function($$v) {
                          _vm.$set(_vm.form, "notifyLine" + i, $$v)
                        },
                        expression: "form['notifyLine'+i]"
                      }
                    })
                  ],
                  1
                )
              })
            ],
            2
          ),
          _vm.elementDict.alsoNotify.slaveVisible
            ? _c(
                "div",
                { attrs: { slot: "alsoNotify" }, slot: "alsoNotify" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.alsoNotify.isRequire ? "blue" : "",
                    staticStyle: {
                      display: "inline-block",
                      "line-height": "28px",
                      "padding-bottom": "5px"
                    },
                    attrs: { label: _vm.elementDict.alsoNotify.label }
                  }),
                  _c("br"),
                  _c("cargo-textarea", {
                    staticClass: "also-notify",
                    attrs: {
                      no: "alsoNotify",
                      type: "textarea",
                      rows: 12,
                      disabled: _vm.readonly
                    },
                    nativeOn: {
                      dblclick: function($event) {
                        return _vm.showAdvanceTextDialog(
                          _vm.elementDict.alsoNotify.label,
                          _vm.form.alsoNotify,
                          _vm.notUppercaseShipperConsigneNotify,
                          function(val) {
                            _vm.form.alsoNotify = val
                          }
                        )
                      }
                    },
                    model: {
                      value: _vm.form.alsoNotify,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "alsoNotify", $$v)
                      },
                      expression: "form.alsoNotify"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.rateType && _vm.elementDict.rateType.slaveVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "rateType" }, slot: "rateType" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.rateType.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.rateType.label
                    },
                    slot: "label"
                  }),
                  _c(
                    "el-select",
                    {
                      attrs: {
                        disabled: _vm.readonly,
                        no: "rateType",
                        clearable: "",
                        placeholder: _vm.$t("SeaExport.PleaseSelect"),
                        size: "mini"
                      },
                      model: {
                        value: _vm.form.rateType,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "rateType", $$v)
                        },
                        expression: "form.rateType"
                      }
                    },
                    _vm._l(_vm.rateType, function(item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: {
                          label: _vm.isZh ? item.chineseName : item.englishName,
                          value: item.code
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        2
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            no: "contact",
            visible: _vm.contactDialog.visible,
            title: _vm.$t("SeaExport.ContactPerson"),
            width: "400px",
            "close-on-click-modal": false,
            "close-on-press-escape": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.contactDialog, "visible", $event)
            }
          }
        },
        [
          _c(
            "el-form",
            { attrs: { "label-position": "right", "label-width": "100px" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.ContactPerson") + "：" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "170px" },
                    attrs: {
                      disabled: true,
                      value: _vm.contactDialog.data.contactPerson,
                      no: "contactPerson"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.Role") + "：" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "170px" },
                    attrs: {
                      disabled: true,
                      value: _vm.contactDialog.data.role,
                      no: "role"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.Tel") + "：" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "170px" },
                    attrs: {
                      disabled: true,
                      value: _vm.contactDialog.data.telephone,
                      no: "telephone"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.Mobile") + "：" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "170px" },
                    attrs: {
                      disabled: true,
                      value: _vm.contactDialog.data.mobile,
                      no: "mobile"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.Fax") + "：" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "170px" },
                    attrs: {
                      disabled: true,
                      value: _vm.contactDialog.data.fax,
                      no: "fax"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.Email") + "：" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "170px" },
                    attrs: {
                      disabled: true,
                      value: _vm.contactDialog.data.email,
                      no: "email"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("CargoMsg.Cargo_Remarks") + "：" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "170px" },
                    attrs: {
                      disabled: true,
                      value: _vm.contactDialog.data.remarks,
                      no: "remarks",
                      type: "textarea",
                      rows: 3
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            no: "advanceText",
            visible: _vm.advanceTextDialog.visible,
            title: _vm.advanceTextDialog.title,
            width: "600px",
            "close-on-click-modal": false,
            "close-on-press-escape": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.advanceTextDialog, "visible", $event)
            }
          }
        },
        [
          _c("cargo-rich-textarea", {
            staticStyle: { height: "320px" },
            attrs: {
              disabled: _vm.readonly,
              "warning-count": -1,
              "text-chars": 0,
              "auto-uppercase": _vm.advanceTextDialog.autoUppercase
            },
            model: {
              value: _vm.advanceTextDialog.value,
              callback: function($$v) {
                _vm.$set(_vm.advanceTextDialog, "value", $$v)
              },
              expression: "advanceTextDialog.value"
            }
          }),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isEdit,
                      expression: "isEdit"
                    }
                  ],
                  attrs: { no: "confirm", type: "primary" },
                  on: { click: _vm.finishAdvanceText }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "close" },
                  on: {
                    click: function($event) {
                      _vm.advanceTextDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.close")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c("hs-code-search-dialog", {
        attrs: {
          visible: _vm.hsCodeSearchDialog.visible,
          title: _vm.hsCodeSearchDialog.title,
          "hide-country-code": true
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.hsCodeSearchDialog, "visible", $event)
          },
          callback: _vm.hsCodeSearchDialog.successCallback
        }
      }),
      _c("select-operation-req-dialog", {
        attrs: {
          visible: _vm.selectOperationReqDialog.visible,
          lob: "RE",
          value: _vm.selectOperationReqDialog.value
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.selectOperationReqDialog, "visible", $event)
          },
          callback: function(val) {
            _vm.form.operationContent = val
          }
        }
      }),
      _c("select-surcharge-terms-dialog", {
        attrs: {
          visible: _vm.selectSurchargeTermsDialog.visible,
          "job-uuid": _vm.form.uuid,
          "row-data": _vm.selectSurchargeTermsDialog.rowData,
          disabled: _vm.readonly
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.selectSurchargeTermsDialog, "visible", $event)
          },
          callback: _vm.handleSurchargeTerms
        }
      }),
      _c("bill-address-dialog", {
        attrs: { visible: _vm.billAddressDialog.visible, job: _vm.form },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.billAddressDialog, "visible", $event)
          },
          callback: _vm.codeSearchCallback
        }
      }),
      _c("fba-bill-address-dialog", {
        attrs: { visible: _vm.fbaBillAddressDialog.visible, job: _vm.fbaJob },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.fbaBillAddressDialog, "visible", $event)
          },
          callback: _vm.fbaCodeSearchCallback
        }
      }),
      _c("stamp-picture-view", {
        attrs: {
          visible: _vm.stampPictureView.visible,
          "business-documents": _vm.stampPictureView.businessDocuments
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.stampPictureView, "visible", $event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }